import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/renthouse/rhServiceMember/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/renthouse/rhServiceMember/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/renthouse/rhServiceMember/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/renthouse/rhServiceMember/delete/${id}`)
}
